/*
 *  Developed by CQ Inversiones SAS. Copyright (c) 2024. All rights reserved.
 *  Desarrollado por CQ Inversiones SAS. Copyright (c) 2024. Todos los derechos reservados.
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez
 * Date:         30/04/24 - 09:54:30
 * Module name:  headers-groups-table.const
 * File name:    headers-groups-table.const.ts
 * IDE:          WebStorm
 */

import {
  TableColumnAlignEnum,
  TableColumnEnum,
  TableColumnInterface,
} from '@shared/components/table';

/**
 * @description
 * Header array for group table child
 */
export const GROUP_MAIN_HEADERS: TableColumnInterface[] = [
  {
    field: 'name',
    type: TableColumnEnum.text,
    header: 'app.setting.group.fields.name.header',
    align: TableColumnAlignEnum.center
  },
  {
    field: 'users',
    type: TableColumnEnum.initialsGroup,
    header: 'app.setting.group.fields.users',
    align: TableColumnAlignEnum.center
  },
  {
    field: 'contacts',
    type: TableColumnEnum.initialsGroup,
    header: 'app.setting.group.fields.contacts',
    align: TableColumnAlignEnum.center
  },
  {
    field: 'enabled',
    type: TableColumnEnum.tag,
    header: 'app.setting.group.fields.status',
    align: TableColumnAlignEnum.center
  },
];

/**
 * @description
 * Header child array for group table child
 */
export const GROUP_CHILD_HEADERS: TableColumnInterface[] = [
  {
    field: 'location',
    type: TableColumnEnum.text,
    header: 'app.setting.group.fields.deviceName',
    align: TableColumnAlignEnum.center,
  },
  {
    field: 'serial',
    type: TableColumnEnum.text,
    header: 'app.setting.group.fields.serial',
    align: TableColumnAlignEnum.center,
  },
  {
    field: 'model',
    type: TableColumnEnum.text,
    header: 'app.setting.group.fields.model',
    align: TableColumnAlignEnum.center,
  },
  {
    field: 'enabled',
    type: TableColumnEnum.tag,
    header: 'app.setting.group.fields.status',
    align: TableColumnAlignEnum.center
  },
  {
    field: 'fw_version',
    type: TableColumnEnum.text,
    header: 'app.setting.group.fields.fw_version',
    align: TableColumnAlignEnum.center,
  },
];
